import axios from 'axios';
import base_api from './base_api';
import store from '../../redux/store';
import { userOperations } from '../../redux/user';

const config = {
    baseURL: __SMART_ISO_BACKEND_BASE__,
    headers: {
        'X-Requested-With': 'xhr',
    },
};

let axios1 = axios.create(config);
let axios_without_interceptors = axios.create(config);
const CancelToken = axios.CancelToken;

axios1.interceptors.request.use(
    async function (config) {
        base_api.defaults.headers['Authorization'] =
            'Bearer ' + store.getState().tokenReducer.tokens.loginToken;

        try {
            const response = await base_api.get('check_login');
            if (response.status === 200) {
                return config;
            }
        } catch (error) {
            store.dispatch(userOperations.userLogoutOp());
            // sessionStorage.clear();
            // localStorage.clear();
            // window.location.reload();
            return {
                ...config,
                cancelToken: new CancelToken((cancel) =>
                    cancel('Please log in again')
                ),
            };
        }

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

axios1.interceptors.response.use(null, function (error) {
    if (error && error.response && error.response.status === 401) {
        sessionStorage.clear();
        localStorage.clear();
        // window.location.reload();
    }
    return Promise.reject(error);
});

export { axios_without_interceptors };

export default axios1;



// WEBPACK FOOTER //
// ./src/utils/api/surchx_base_api.js